import { isArray } from "lodash";
import { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";


import { usePymbleApi } from "./usePymbleApi";

// const MY_ROOMS_END_POINT = `${api.dtAdmin}/room/timetable`;
const MY_ROOMS_END_POINT = "/timetable/room/timetable/";

export type RoomTimetableDetail = {
  start: string;
  end: string;
  title: string;
  resource: string;
};

/**
 * Hook for separate loading of a class list
 * for components
 */
export function useRoomTimetable(date: string) {
  const [roomTimetable, setRoomTimetable] = useState<any>([]);
  const [roomTimetableLoaded, setRoomTimetableLoaded] = useState(false);

  const queryClient = useQueryClient();

  const { callApiS2: callApi, isAuthenticated } = usePymbleApi();

  // Load the contact list from api
  let queryKey = ["my-room-timetable", date];

  const { isLoading, isError, data, error } = useQuery({
    queryKey,
    queryFn: () =>
      callApi(
        "GET",
        MY_ROOMS_END_POINT + "?qtype=timetable&timetable_type=&date=" + date,
      ),
    enabled: isAuthenticated,
    staleTime: 1000,
  });

  // When the data is loaded, set the state
  useEffect(() => {
    if (data && data.length) {
      // let list = preProcessRoomTimetable(data);

      // Sort by name
      // list = sortRoomTimetable(list);

      // if (list) {
      setRoomTimetable(data);
      // }
      setRoomTimetableLoaded(true);
    }
  }, [data, isLoading]);

  const refreshRoomTimetable = async () => {
    await queryClient.invalidateQueries({ queryKey });
    // Refetch in the background
    queryClient.fetchQuery({ queryKey, queryFn: () =>
      callApi(
        "GET",
        MY_ROOMS_END_POINT + "?qtype=timetable&timetable_type=&date=" + date,
      ),
    });
  };

  // Only sort by start time at the moment
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const sortRoomTimetable = (data: RoomTimetableDetail[]) => {
    return data.sort(function (a: RoomTimetableDetail, b: RoomTimetableDetail) {
      try {
        if (a && a?.title && b && b?.title) {
          let NameA = a?.title;
          let NameB = b?.title;
          if (NameA < NameB) {
            return -1;
          }
          if (NameA > NameB) {
            return 1;
          }
        }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        /* squash */
      }
      // names must be equal or documents incorrect
      return 0;
    });
  };

  // Decorate as required
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const preProcessRoomTimetable = (classdata: any) => {
    if (isArray(classdata)) {
      return classdata.map((c: any) => {
        return c;
      });
    } else {
      return [];
    }
  };

  const updateRoomTimetables = (events: any) => {
    queryClient.setQueryData(queryKey, events);
  };

  return {
    isError,
    isLoading,
    error,
    roomTimetable,
    refreshRoomTimetable,
    roomTimetableLoaded,
    updateRoomTimetables,
  };
}
